import log from "../../../bizark_fe_mods/src/components/templates/log.vue";

<style lang="scss" scoped>
</style>

<template>
	<div>
		<compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
			<compFormEdit
				ref="formbase"
				align="center"
				class="margin-top-15"
				:formdata="getBase"
				v-model="packageBase"
			></compFormEdit>
		</compWrapper>
		<compWrapper :title="$t('fbb.settlement.alladress',{defaultValue:'收/发货地址信息'})" theme="info">
			<compFormEdit
				ref="address"
				align="center"
				class="margin-top-15"
				:formdata="getAddress"
				v-model="packageAddress"
			></compFormEdit>
		</compWrapper>
		<compWrapper :title="$t('fbb.fedex.package_size',{defaultValue:'包裹尺寸'})" theme="warning">
			<vAlert class="margin-15" theme="error">{{$t('fbb.fedex.packagesize_tip',{defaultValue:'包裹长、宽、高请输入正整数，若输入小数，则自动向上取整；包裹重量保留小数点后两位，超过两位则四舍五入保留两位'})}}</vAlert>
			<compFormEdit
				ref="package"
				align="center"
				class="margin-top-15"
				:formdata="getPackage"
				v-model="packageSize"
			></compFormEdit>
			<footer class="width-50per" style="padding-left:120px;margin-left:25%;">
				<vButton theme="primary" class="margin-right-15" @click="calculate">{{$t('fbb.fedex.calc_measure',{defaultValue:'开始测算'})}}</vButton>
				<vButton theme="error" class="margin-right-15" @click="reset">{{$t('global.common.btn_reset',{defaultValue:'重置'})}}</vButton>
			</footer>
		</compWrapper>
		<compWrapper title="测算结果" theme="info">
			<vAlert
				class="margin-15"
				theme="warning"
			>{{$t('fbb.fedex.calc_bigtip',{defaultValue:'特别说明：测算的费用包含部分附加费,如：燃油附加费、地址附加费、超长超重附加费等；FedEx是账单制度，签收包裹后会根据官方实际账单产生额外费用，如：成人签字附加费、地址更改费等，实际费用以账单为准，计费重量是包裹毛重和体积重两者取大者，使用FedEX Ground、FedEX Home Delivery两种服务时，若加收Oversize费用时，若包裹计费重量不足90lb时，按90lb计算'})}}</vAlert>
			<compCalc :data="calcList"></compCalc>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import { HttpPackageCalc,HttpFindOrgCorrespWare } from "@/service/fedex";
import { HttpOtherLogiServiceList,HttpGetCarrierGroupByOrg } from "@/service/carrieraccount";
import compCalc from "./calc";
import mixin from './mixin';

export default {
	mixins: [mixin],
	components: {
		compCalc,
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit")
	},
	data() {
		return {
			loading: false,
			packageBase: {
				orgId: this.$store.state.organization.id,
				carrierCode: "",
			},
            carrierList: [],
            carrierServiceList:HttpOtherLogiServiceList({
                contextId:global.SYSID,
                carrierGroupId: 0,
            }).then(
                (res) => {
                    this.carrierServiceList = res.data.map(item => {
                        return {
                            value: item.carrierServiceCode,
                            label: item.carrierServiceCode,
                            attach: {
                                ...item
                            }
                        }
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            ),
			packageAddress: {
				shipCountry: "US",
				receiveCountry: "US",
				// shipPostal:"94546",
				// receivePostal:"94533"
			},
			packageSize: {
				sizeUnit: "inch",
				// length:"1",
				// width:"1",
				// height:"1",
				// height:"1",
				weightUnit: "lbs",
				// weight:"1",
			},
			calcList: [],
			warehouseList:[],
		};
	},
    created() {
        // this.getCarrierList(this.packageBase.orgId);
        this.getGroupServiceList(0);
    },
	mounted(){
		this.getOrgCorrespWare(this.packageBase.orgId)
	},
	computed: {
		getBase() {
			const carrierCode = this.packageBase.carrierCode;
			return [
				{
					label: this.$t('bi.work.task_org_id',{defaultValue:'组织'}),
					tag: "vSelect",
					key: "orgId",
					options: this.getOrgOpt,
					on:{
						'on-change':(val)=>{
							this.getOrgGroupList(val);
                            this.getOrgCorrespWare(val);
						}
					},
					props: {
						filterable: true
					},
				},
				{
					label: this.$t('fbb.alloment.carrier_code',{defaultValue:'物流商'}),
					tag: "vSelect",
					key: "groupId",
					options: this.carrierList,
					props: {
						filterable: true
					},
                    on:{
                        'on-change':(val)=>{
                            this.getGroupServiceList(val);
                        }
                    },
					required: false,
				},
				{
					label: this.$t('fbb.alloment.carrier_server',{defaultValue:'物流商服务'}),
					tag: "vSelect",
					key: "logisticsServiceCode",
					options: this.carrierServiceList,
					props: {
						filterable: true
					},
					required: false,
				},
			];
		},
		getAddress() {
			return [
				{
					label: this.$t('fbb.settlement.shipCountry',{defaultValue:'发货地国家'}),
					tag: "vSelect",
					key: "shipCountry",
					options: this.getCountryList
				},
				{
                    label: this.$t('global.common.deliveryWarehouse',{defaultValue:'发货仓库'}),
                    tag: 'vSelect',
                    key: 'shipOrgWarehouseCode',
                    options:this.warehouseList,
                    required:false,
                    props:{
                        filterable:true,
                    }
				},
				{
					label: this.$t('fbb.settlement.shipPostal',{defaultValue:'发货地邮编'}),
                    key: "shipPostal",
                    required:false,
				},
				// {
				// 	label: "发货地邮编",
				// 	key: "shipPostal",
				// 	formItem: {
				// 		rules: {
				// 			required: true,
				// 			// message: "该信息不能为空,请填写",
				// 			validator(rule, value, callback) {
				// 				if (!value || !/^[0-9]{5,}$/g.test(value)) {
				// 					callback('该信息不能为空,且长度不能少于五位');
				// 				} else {
				// 					callback();
				// 				}
				// 			},
				// 		},
				// 	}
				// },
				{
					label: this.$t('fbb.settlement.receiveCountry',{defaultValue:'收货地国家'}),
					tag: "vSelect",
					key: "receiveCountry",
					options: this.getCountryList
				},
				{
					label: this.$t('fbb.settlement.receiveState',{defaultValue:'收货地州/省'}),
					key: "receiveState",
					required: false,
				},
				{
					label: this.$t('fbb.settlement.receiveCity',{defaultValue:'收货地城市'}),
					key: "receiveCity",
					required: false,
				},
                {
					label: this.$t('fbb.settlement.receivePostal',{defaultValue:'收货地邮编'}),
                    key: "receivePostal",
                    required:true,
				},
				// {
				// 	label: this.$t('fbb.settlement.receivePostal',{defaultValue:'收货地邮编'}),
				// 	key: "receivePostal",
				// 	formItem: {
				// 		rules: {
				// 			required: true,
				// 			message: "该信息不能为空,请填写",
				// 			validator(rule, value, callback) {
				// 				if (!value || !/^[0-9-0-9]{5,}$/g.test(value)) {
				// 					callback(this.$t('fbb.fedex.receivecode_tip',{defaultValue:'该信息不能为空,且长度不能少于五位'}));
				// 				} else {
				// 					callback();
				// 				}
				// 			},
				// 		},
				// 	}
				// },
				{
					label: this.$t('erp.b2c.shipping_address',{defaultValue:'收货地'}),
					tag: "vTextarea",
					key: "receiveAddress",
					required: false,
				},
				{
					label: this.$t('fbb.fedex.address_attr',{defaultValue:'地址属性'}),
					tag: "vCheckBox",
					key: "isResidential",
					required: false,
					props: {
						trueValue: 1,
						falseValue: 0,
					},
					children(h) {
						return <div>{this.$t('fbb.fedex.address_per',{defaultValue:'住宅地址'})}<span class="color-error padding-left-20">{this.$t('fbb.fedex.address_pertip',{defaultValue:'若勾选，则默认为住宅地址进行运费测算'})}</span></div>
					},
				},
			]
		},
		getPackage() {
			return [
				{
					label: this.$t('fbb.fedex.sizeUnit',{defaultValue:'尺寸单位'}),
					tag: "vSelect",
					key: "sizeUnit",
					options: [{
						label: "inch（英寸）",
						value: "inch"
					}, {
						label: "cm（厘米）",
						value: "cm"
					}]
				}, {
					label: this.$t('fbb.fedex.sizeBase',{defaultValue:'尺寸信息'}),
					tag: "vInputNumber",
					key: "length",
					span: "6",
					offset: 6,
					props: {
						placeholder: this.$t('global.common.length',{defaultValue:'长'}),
						precision: 0,
						math: "ceil",
						min: 1
					},
				}, {
					// label: "尺寸信息",
					tag: "vInputNumber",
					key: "width",
					span: "4",
					offset: 0,
					props: {
						placeholder: this.$t('global.common.width',{defaultValue:'宽'}),
						precision: 0,
						math: "ceil",
						min: 1
					},
					formItem: {
						labelWidth: 30,
					}
				}, {
					// label: "尺寸信息",
					tag: "vInputNumber",
					key: "height",
					span: "4",
					offset: 0,
					props: {
						placeholder: this.$t('global.common.height',{defaultValue:'高'}),
						precision: 0,
						math: "ceil",
						min: 1
					},
					formItem: {
						labelWidth: 30,
					}
				}, {
					label: this.$t('fbb.headlogistics.weight_unit',{defaultValue:'重量单位'}),
					tag: "vSelect",
					key: "weightUnit",
					options: [{
						label: "lbs（磅）",
						value: "lbs"
					}, {
						label: "oz（盎司）",
						value: "oz"
					}, {
						label: "g（克）",
						value: "g"
					}]
				}, {
					label: this.$t('fbb.expresspackage.package_weight',{defaultValue:'包裹重量'}),
					tag: "vInputNumber",
					key: "weight",
					props: {
						precision: 2,
						min: 0
					}
				},
			]
		},
	},
	methods: {
		reset() {
			this.packageBase = {};
			this.packageAddress = {};
			this.packageSize = {};
			this.calcList = [];
			this.$refs.formbase.resetValidate();
			this.$refs.address.resetValidate();
			this.$refs.package.resetValidate();
		},
        getOrgGroupList(val) {
            HttpGetCarrierGroupByOrg({
                contextId:global.SYSID,
                orgId: val,
            }).then(
                (res) => {
                    this.carrierList = res.data.map(item => {
                        return {
                            value: item.carrierGroupId,
                            label: item.carrierGroupName,
                            attach: {
                                ...item
                            },
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        getGroupServiceList(val) {
            HttpOtherLogiServiceList({
                contextId:global.SYSID,
                carrierGroupId: val,
            }).then(
                (res) => {
                    this.carrierServiceList = res.data.map(item => {
                        return {
                            value: item.code,
                            label: item.code,
                            attach: {
                                ...item
                            },
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
		getOrgCorrespWare(val){
			HttpFindOrgCorrespWare({
				orgId:val
			}).then(res=>{
				this.warehouseList = res.data.map(item=>{ return {label:item.title + ' ('+item.code+')',value:item.code} })
				// console.log(res.data)
			},err=>{

			});
		},
		async calculate() {
			const valid = await Promise.all([this.$refs.formbase.validate(), this.$refs.address.validate(), this.$refs.package.validate()]);
			if (!valid) return;
			if(!this.packageAddress.shipOrgWarehouseCode && !this.packageAddress.shipPostal) {
                this.$VMessage.error('发货仓库和发货邮编必填其一')
                return
            }
			this.loading = true;
			HttpPackageCalc({
				calculationPackageBaseInfoItem: this.packageBase,
				calculationPackageAddressItem: this.packageAddress,
				calculationPackageItem: this.packageSize,
			}).then(
				res => {
					this.calcList = res.data || [];
					this.loading = false;
				},
				err => {
					this.loading = false;
					this.$VMessage.error(err.message);
				}
			);
		}
	}
}
</script>
